export const solutionCategories = [
  {
    icon: 'briefcase',
    title: 'Business Consulting',
    description:
      'Executive-level guidance that turns strategy into standardized daily operations.',
    services: [
      'Operational Assessments',
      'Business Audits',
      'Growth Planning',
      'SOP Development',
      'Executive Coaching',
    ],
  },
  {
    icon: 'dollar',
    title: 'Financial Solutions',
    description:
      'Protect margin with disciplined cost control and clear financial reporting.',
    services: [
      'Profit Analysis',
      'Cost Controls',
      'Budget Development',
      'KPI Dashboards',
    ],
  },
  {
    icon: 'boxes',
    title: 'Operations',
    description:
      'Systems that keep inventory, purchasing, and labor performing consistently.',
    services: [
      'Inventory Systems',
      'Purchasing',
      'Vendor Management',
      'Recipe Costing',
      'Labor Optimization',
    ],
  },
  {
    icon: 'monitor',
    title: 'Technology',
    description:
      'ROI Complete Software puts real-time performance in the palm of your hand.',
    services: [
      'Dashboards',
      'Reporting',
      'AI Insights',
      'Mobile App',
      'Cloud-Based Platform',
      'Multi-location Support',
    ],
  },
  {
    icon: 'graduation',
    title: 'Training',
    description:
      'Develop the leaders and teams who have to run the system every day.',
    services: [
      'Leadership Development',
      'Management Training',
      'Staff Training',
      'Online Courses',
    ],
  },
]
